import { NavLink } from "react-router-dom";
import '../../stylesheets/Box.scss';

export function LoadingBox(props) {
  // allow overrides, but keep your current defaults
  const number = props?.number ?? 4;
  const text = props?.text ?? "Documents Required";

  const lines = String(text).split("\n");

  return (
    <div className="box loading-box">
      <div className="box-numb">
        <p>{number}</p>
      </div>
      <div className="box-text">
        {lines.map((line, idx) => (
          <p key={idx}>{line}</p>
        ))}
      </div>
    </div>
  );
}

export function Box(props) {
  const link = props?.link || "shipments";
  const text = props?.text || "";

  // support manual line breaks using "\n"
  const lines = String(text).split("\n");

  return (
    <NavLink to={link} className="box">
      <div className="box-numb">
        <p>{props?.number}</p>
      </div>
      <div className="box-text">
        {lines.map((line, idx) => (
          <p key={idx}>{line}</p>
        ))}
      </div>
    </NavLink>
  );
}
